
import React from 'react';
import Layout from '@/components/layout/Layout';
import ChartAlerts from '@/components/analytics/ChartAlerts';

const Charts: React.FC = () => {
  return (
    <Layout>
      <div className="container max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Chart Performance</h1>
        <p className="text-muted-foreground mb-8">Track your music's performance on charts around the world</p>
        <ChartAlerts />
      </div>
    </Layout>
  );
};

export default Charts;
